export default __webpack_public_path__ + "static/media/covid-image.e024471d.svg";